import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {TooltipDirective} from '@buildinginformationcloud/bic-ui-components';
import {
  faArrowRight,
  faClipboardList,
  faFile,
  faFileLines,
  faPlay,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'my-checks-builder-stepper',
  standalone: true,
  imports: [FaIconComponent, TooltipDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './builder-stepper.component.html',
})
export class BuilderStepperComponent {
  @Input() currentStep = 0;
  /** Schritt-Indizes mit fehlenden Pflichtangaben (Warn-Markierung). */
  @Input() invalidSteps: number[] = [];
  @Output() stepChange = new EventEmitter<number>();

  faArrowRight = faArrowRight;
  faTriangleExclamation = faTriangleExclamation;

  steps = [
    {index: 0, title: 'Allgemeine Prüfeinstellungen', subtitle: 'Grundeinstellungen und Auslöser', icon: faPlay},
    {index: 1, title: 'Regelauswahl', subtitle: 'Anzuwendende Prüfregel', icon: faClipboardList},
    {index: 2, title: 'Dateiauswahl', subtitle: 'Zu prüfende Dateien', icon: faFile},
    {index: 3, title: 'Bericht erstellen', subtitle: 'Format und Sprache', icon: faFileLines},
  ];

  isStepReached(stepIndex: number): boolean {
    return stepIndex <= this.currentStep;
  }

  /** Ob für den Schritt eine Pflichtangabe fehlt. */
  isStepInvalid(stepIndex: number): boolean {
    return this.invalidSteps.includes(stepIndex);
  }
}
